
import React from 'react';


import {connect} from 'react-redux';
import html2pdf from 'html2pdf.js';
import LoftyDropdownComponent from '../../components/loftydropdowncomponent';
import LoftyCountDown from '../../components/loftycountdown';
import LoftyCartCarousel from '../../components/loftycartcarousel';
import LoftyThreeCarousel from '../../components/loftythreecarousel';
import LoftyCarouselPlugin from '../../components/LoftyCarouselPlugin';
import LoftyLeaftMap from '../../components/loftyLeaftMaps';
import LoftyAnimatedParticleBackground from '../../components/loftyAnimatedParticleBackground';
import LoftyGoogleLoginComponent from '../../components/loftyGoogleLoginComponent';

import { addLoftyToken, deleteLoftytoken } from '../../actions/auth.actions';


import './paginadeerror404voou3.scss';






const Ppaginadeerror404voou3 = ({
  match,
  history,
  loftytoken,
  loftyuser,
  addLoftyUserApp,
  deleteLoftytokenApp,
  addLoftyTokenApp,
  
}) => {





  
  
  
  

  
  return (
    <div id="id6897a68d8e5aed52dc7b4e02" >

      <div id="idcr" className="">
      
      <div id="if3j" className="">
      
      <div id="iuk9j" className="">
      
        <a
          target=""
          className="link-menu "
          id="ij9z9"
          href="/#sobremi"
        >
          
    <div id="id9bi" className="">
    <>Sobre mi</>
    </div>
    
        </a>
        
        <a
          target=""
          className="link-menu "
          id="i0vzh"
          href="/#experiencia"
        >
          
    <div id="izdhk" className="">
    <>Experiencia</>
    </div>
    
        </a>
        
        <a
          target=""
          className="link-menu "
          id="ibddn"
          href="/#educacion"
        >
          
    <div id="ih96q" className="">
    <>Educación</>
    </div>
    
        </a>
        
        <a
          target=""
          className="link-menu "
          id="iehu4"
          href="/#libros"
        >
          
    <div id="iiytk" className="">
    <>Libros</>
    </div>
    
        </a>
        
        <a
          target=""
          className="link-menu "
          id="ig72a"
          href="/#contacto"
        >
          
    <div id="i1ciz" className="">
    <>Contáctame</>
    </div>
    
        </a>
        
      </div>
      
      </div>
      
      <div id="contacto" className="">
      
      <div
        id="ifittv"
        className="container-iinfo "
        data-aos="fade-up"
        data-aos-duration="undefined"
      >
      
      <div id="ixdj1k" className="">
      
      <div
        id="ifa6ds"
        className=""
        data-aos="fade-down"
        data-aos-duration="1200"
      >
      
      <div id="i19yc4" className="">
      
      </div>
      
      <div id="imkdit" className="">
      
      <div className="" id="io7hwg">
        <>Error 404</>
      </div>
      
      <img
        className=""
        id="ips189"
        src="https://assetsprojects.s3.amazonaws.com/404pziime4nndbw.png"
        alt="undefined"
      />
      
      </div>
      
      </div>
      
      <div id="ibhsgl" className="">
      
      <div className="" id="igplt8">
        <>¡Ups! Página no encontrada</>
      <br className="" id="" />
      <>Parece que el enlace que buscabas no existe o fue movido.</>
      <br className="" id="" />
      <>Puedes volver al inicio o explorar nuestro contenido para encontrar lo que necesitas.</>
      </div>
      
      <div id="itiy1" className="">
      
        <a
          target=""
          className="boton-principal "
          id="ihkt5"
          href={`/`}
        >
          
    <div id="itgnk" className="">
    <>Ir a la página principal</>
    </div>
    
        </a>
        
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="i82i5" className="">
      
      <div id="i3wet5" className="">
      
      <div id="iolpr7" className="">
      
      <img
        className=""
        id="i3jisj"
        src="https://assetsprojects.s3.amazonaws.com/404pziime4nb2a7.png"
        alt="undefined"
      />
      
      </div>
      
      <div id="i9bcbd" className="">
      
        <a
          target=""
          className="link-menu "
          id="i2tta2"
          href="#sobremi"
        >
          
    <div id="ivw9gj" className="">
    <>Sobre mi</>
    </div>
    
        </a>
        
        <a
          target=""
          className="link-menu "
          id="i7rtlz"
          href="#experiencia"
        >
          
    <div id="i44uop" className="">
    <>Experiencia</>
    </div>
    
        </a>
        
        <a
          target=""
          className="link-menu "
          id="i3bw7x"
          href="#educacion"
        >
          
    <div id="ix9y1i" className="">
    <>Educación</>
    </div>
    
        </a>
        
        <a
          target=""
          className="link-menu "
          id="ik8cbw"
          href="#libros"
        >
          
    <div id="isvi9f" className="">
    <>Libros</>
    </div>
    
        </a>
        
        <a
          target=""
          className="link-menu "
          id="i71f0p"
          href="#contacto"
        >
          
    <div id="iv0dv4" className="">
    <>Contáctame</>
    </div>
    
        </a>
        
      </div>
      
      <div id="ivgr2j" className="">
      
        <a
          target="_blank"
          className=""
          id="i7cf33"
          href="https://www.instagram.com/carlosgcalix/"
        >
          
      <img
        className=""
        id="i3mnfv"
        src="https://assetsprojects.s3.amazonaws.com/404pziime4jj58l.png"
        alt="undefined"
      />
      
        </a>
        
        <a
          target="_blank"
          className=""
          id="ic4w45"
          href="https://www.linkedin.com/in/carlos-g-c%C3%A1lix-27b524a3/"
        >
          
      <img
        className=""
        id="iim9aw"
        src="https://assetsprojects.s3.amazonaws.com/404pziime4jktmy.png"
        alt="undefined"
      />
      
        </a>
        
        <a
          target="_blank"
          className=""
          id="idipwo"
          href="https://www.facebook.com/carlosgcalix"
        >
          
      <img
        className=""
        id="i5gmgv"
        src="https://assetsprojects.s3.amazonaws.com/404pziime4jl24g.png"
        alt="undefined"
      />
      
        </a>
        
      </div>
      
      <div id="ie26zw" className="">
      
      <div id="i4ib3g" className="">
      
      <img
        className=""
        id="ijanjc"
        src="https://assetsprojects.s3.amazonaws.com/404pziime4nhbcd.png"
        alt="undefined"
      />
      
        <a
          target="_blank"
          className=""
          id="ia15ah"
          href="mailto:cgcalixg@gmail.com"
        >
          
    <div id="iu5j2a" className="">
    <>cgcalixg@gmail.com</>
    </div>
    
        </a>
        
      </div>
      
      </div>
      
      <div id="irsy0f" className="">
      
      </div>
      
      <div className="" id="id9asw">
        <>Todos los derechos reservados ©. Carlos G. Calix 2025 </>
      </div>
      
      </div>
      
      </div>
      
      </div>
      
</div>
  );
}

const mapStateToProps = (state) => state.auth;

const mapDispatchToProps = (dispatch) => ({
 addLoftyTokenApp: (data) => dispatch(addLoftyToken(data)),
 deleteLoftytokenApp: () => dispatch(deleteLoftytoken()),
});


export default connect(mapStateToProps, mapDispatchToProps)(Ppaginadeerror404voou3);
  